import axios from 'axios';
import { HUBSPOT_PORTAL_ID } from '../constants';

export const hubspotClient = axios.create({
  baseURL: 'https://api.hsforms.com/',
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface HubspotFormOptions {
  pageName?: string;
}

export interface HubspotFormField {
  name: string;
  objectTypeId?: string;
  value: string;
}

export const submitFormToHubspot = async (formGuid: string, fields: HubspotFormField[], options?: HubspotFormOptions) =>
  await hubspotClient.post(`submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${formGuid}`, {
    submittedAt: new Date().getTime(),
    fields,
    context: {
      pageUri: 'https://eat.nibll.com',
      pageName: options?.pageName || 'NIBLL Home'
    },
    legalConsentOptions: {
      consent: {
        consentToProcess: true,
        text: 'I agree to allow NIBLL to store and process my personal data.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 999,
            text: 'I agree to receive marketing communications from NIBLL.'
          }
        ]
      }
    }
  });
